export default "__VITE_ASSET__997ddc44__"